if (!customElements.get("variant-selects")) {
  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === "true";
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener("change", this.onVariantChange);
      this.other = Array.from(
        document.querySelectorAll("variant-selects")
      ).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest(".thb-product-detail");
      this.productSlider = this.productWrapper.querySelector(".product-images");
      this.hideVariants = this.dataset.hideVariants === "true";
      const lowP = document.querySelector("#am-omnibus-block");
      if (lowP) {
        new MutationObserver(() => {
          this.updateMinPrice(fryPrice);
        }).observe(lowP, { childList: true });
      }
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();

      const trade_button = document.getElementById("trade-in-btn");
      const quick_link = document.getElementById("bid_quick_view_link");
      if (trade_button) trade_button.classList.remove("disabled-link");
      if (quick_link) {
        if (quick_link.dataset.disabled === "0") {
          quick_link.classList.remove("disabled-link");
        }
      }

      const dealer_text = document.getElementById("prod-sold-by");

      if (!this.currentVariant) {
        this.toggleAddButton(true, "", true);
        this.setUnavailable();
        if (trade_button) trade_button.classList.add("disabled-link");
        if (quick_link) quick_link.classList.add("disabled-link");
        if (dealer_text) dealer_text.classList.add("hidden");
      } else {
        if (!this.currentVariant.available) {
          if (trade_button) trade_button.classList.add("disabled-link");
          if (quick_link) quick_link.classList.add("disabled-link");
        }

        if (quick_link) {
          quick_link.href = `${quick_link.dataset.url}?variant=${this.currentVariant.id}&bid=true`;
        }

        let d = this.currentVariant.option1.split("-");
        if (this.currentVariant.option1) {
          if (
            this.currentVariant.option1 == "Bikeroom" ||
            this.currentVariant.option1 == "002"
          ) {
            if (dealer_text) dealer_text.classList.add("hidden");
          } else {
            if (dealer_text) dealer_text.classList.remove("hidden");
          }
        }

        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }

      this.updateBid();
      this.watchProtectionPriceSource();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, "", false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      const trade_button = document.getElementById("trade-in-btn");
      const quick_link = document.getElementById("bid_quick_view_link");
      if (trade_button) trade_button.classList.remove("disabled-link");
      if (quick_link) {
        if (quick_link.dataset.disabled === "0") {
          quick_link.classList.remove("disabled-link");
        }
      }

      const dealer_text = document.getElementById("prod-sold-by");

      if (typeof priceChangeMutation !== "undefined") {
        priceChangeMutation.observe(
          document.getElementById(`price-${this.dataset.section}`),
          { childList: true, subtree: true }
        );
      }

      if (!this.currentVariant) {
        this.toggleAddButton(true, "", true);
        this.setUnavailable();
        if (trade_button) trade_button.classList.add("disabled-link");
        if (quick_link) quick_link.classList.add("disabled-link");
        if (dealer_text) dealer_text.classList.add("hidden");
      } else {
        if (!this.currentVariant.available) {
          if (trade_button) trade_button.classList.add("disabled-link");
          if (quick_link) quick_link.classList.add("disabled-link");
        }

        if (quick_link) {
          quick_link.href = `${quick_link.dataset.url}?variant=${this.currentVariant.id}&bid=true`;
        }

        let d = this.currentVariant.option1.split("-");
        if (this.currentVariant.option1) {
          if (
            this.currentVariant.option1 == "Bikeroom" ||
            this.currentVariant.option1 == "002"
          ) {
            if (dealer_text) dealer_text.classList.add("hidden");
          } else {
            if (dealer_text) dealer_text.classList.remove("hidden");
          }
        }

        // Update services
        const limit = 2000;
        const ex = Shopify?.exchange_rate;
        const normalized_limit = limit * 100 * ex;

        let title = "Standard";
        let alt_title = "Standard";

        if (!this.currentVariant.taxable) {
          alt_title = "Margin";
          if (this.currentVariant.price > normalized_limit) {
            title = "Margin";
          } else {
            title = "Reduced_margin";
          }
        } else {
          alt_title = "Standard";
          if (this.currentVariant.price > normalized_limit) {
            title = "Standard";
          } else {
            title = "Reduced";
          }
        }

        const items = document.querySelectorAll(".prod-service-price");

        items.forEach((item) => {
          if (item.dataset.s == "true") {
            if (item.dataset.variant === title) {
              item.classList.remove("hidden");
              return;
            }
          } else {
            if (item.dataset.variant === alt_title) {
              item.classList.remove("hidden");
              return;
            }
          }

          item.classList.add("hidden");
        });

        const bidItems = document.querySelectorAll(".bid-dialog-service");

        bidItems.forEach((item) => {
          if (item.dataset.s == "true") {
            if (item.dataset.variant === title) {
              item.classList.remove("hidden");
              return;
            }
          } else {
            if (item.dataset.variant === alt_title) {
              item.classList.remove("hidden");
              return;
            }
          }

          item.classList.add("hidden");
        });

        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }

      this.updateOther();
      this.updateBid();

      this.updateMinPrice();

      dispatchCustomEvent("product:variant-change", {
        variant: this.currentVariant,
        sectionId: this.dataset.section,
      });
    }

    updateBKRMProtectionPrice() {
      const protectionPriceSpan = document.getElementById('bkrm-protection-price');
      if (!protectionPriceSpan) return;
      // The customer-facing bike price can differ from currentVariant.price
      // when an external pricing app overrides the rendered amount
      // (`axt-cp-*` / `.axt_discounted_price`). Read the visible amount
      // first; fall back to variant.price for products without an override.
      // Returns null when no usable source is available (e.g. stub variant
      // built by setMasterId for unmatched option combinations) so the
      // span keeps its last valid value instead of collapsing to €0.
      const cents = this.readDisplayedPriceCents() ?? this.currentVariant?.price;
      if (!cents || cents <= 0) return;
      const protection = (5000 * window.Shopify.exchange_rate) + (cents * 0.03);
      protectionPriceSpan.textContent = window.Shopify.formatMoney(cents + protection);
    }

    updateSavingPercentage() {
      // Recompute the "Save X%" badge from the *currently displayed* prices
      // so the value stays in sync with: (a) the customer-facing override
      // (`.axt_discounted_price`) injected by the pricing app, and (b) the
      // variant-specific compare_at_price, which differs across dealer/size/
      // color combinations on BKRM. The previous implementation pinned the
      // denominator to `product.compare_at_price` (server-rendered once =
      // the product-wide min), so swapping to a variant with a different
      // compare value produced a stale, misleading percentage — and a
      // locale-naive parser turned €5.500,00 into 5.5, yielding "Save 100%".
      const container = document.getElementById(`price-${this.dataset.section}`);
      if (!container) return;
      const discountLabel = container.querySelector('[id^="p-disc-"]');
      if (!discountLabel) return;
      const template = discountLabel.dataset.saveTemplate;
      if (!template) return; // only active when sale_badge_type == 'save_percentage'
      const compareEl = container.querySelector('[id^="compare-"]');
      if (!compareEl) return;
      const priceCents = this.readDisplayedPriceCents();
      const compareCents = this.readDisplayedPriceCents(compareEl);
      if (!priceCents || !compareCents || compareCents <= priceCents) return;
      const pct = Math.round(((compareCents - priceCents) * 100) / compareCents);
      const next = template.replace('__PCT__', `${pct}%`);
      if (discountLabel.innerHTML !== next) discountLabel.innerHTML = next;
    }

    readDisplayedPriceCents(element) {
      let el = element;
      if (!el) {
        const container = document.getElementById(`price-${this.dataset.section}`);
        if (!container) return null;
        el = container.querySelector('.axt_discounted_price')
          || container.querySelector('.amount > span');
      }
      const text = el?.textContent;
      if (!text) return null;
      const stripped = text.replace(/[^\d.,-]+/g, '');
      if (!stripped) return null;
      // Locale-aware decimal detection: the right-most "," or "." is the
      // decimal separator, the other character is the thousands grouping.
      const lastComma = stripped.lastIndexOf(',');
      const lastDot = stripped.lastIndexOf('.');
      let normalized;
      if (lastComma > lastDot) {
        normalized = stripped.replace(/\./g, '').replace(',', '.');
      } else if (lastDot > lastComma) {
        normalized = stripped.replace(/,/g, '');
      } else {
        normalized = stripped;
      }
      const n = parseFloat(normalized);
      if (!Number.isFinite(n)) return null;
      return Math.round(n * 100);
    }

    watchProtectionPriceSource() {
      const container = document.getElementById(`price-${this.dataset.section}`);
      if (!container) return;
      this._protectionObserver?.disconnect();
      this._protectionObserver = new MutationObserver(() => {
        this.updateBKRMProtectionPrice();
        this.updateSavingPercentage();
      });
      this._protectionObserver.observe(container, {
        childList: true,
        subtree: true,
        characterData: true,
      });
      // Initial sync in case the displayed price was already mutated by
      // an app before this observer attached.
      this.updateBKRMProtectionPrice();
      this.updateSavingPercentage();
    }

    updateBid() {
      let bidBtn = document.getElementById("bid-dialog-open-btn");
      if (!this.currentVariant) {
        if (bidBtn) bidBtn.classList.add("disabled-link");
      } else {
        if (!bidBtn) return;

        if (this.currentVariant.available == false) {
          bidBtn.classList.add("disabled-link");
          return;
        }

        if (!enabledVariants || !enabledVariants[this.currentVariant.id]) {
          bidBtn.classList.add("disabled-link");
          return;
        }

        if (
          this.currentVariant.options[0] == "091" ||
          this.currentVariant.options[0] == "096" ||
          this.currentVariant.options[0] == "Zyclora.it" ||
          this.currentVariant.options[0] == "TUVALUM SPORTS SL"
        ) {
          bidBtn.classList.add("disabled-link");
          return;
        }

        try {
          const l = 1200 * Shopify.exchange_rate;
          if (this.currentVariant.price / 100 < l) {
            bidBtn.classList.add("disabled-link");
            return;
          }
        } catch (e) {
          console.error(e);
        }

        bidBtn.classList.remove("disabled-link");

        // update size - color - image
        let size = document.getElementById("bid-product-size");
        let size_sm = document.getElementById("bid-product-size-sm");
        let color = document.getElementById("bid-product-color");
        let color_sm = document.getElementById("bid-product-color-sm");
        let size_sub = document.getElementById("bid-subtotal-item-color-name");
        let color_sub = document.getElementById("bid-subtotal-item-size-name");

        size.innerHTML = this.currentVariant.options[1];
        color.innerHTML = this.currentVariant.options[2];
        size_sm.innerHTML = this.currentVariant.options[1];
        color_sm.innerHTML = this.currentVariant.options[2];
        color_sub.innerHTML = this.currentVariant.options[1];
        size_sub.innerHTML = this.currentVariant.options[2];

        if (this.currentVariant.featured_image) {
          let image = document.getElementById("bid-product-image");
          image.src = this.currentVariant.featured_image.src;

          let image_sm = document.getElementById("bid-product-image-sm");
          image_sm.src = this.currentVariant.featured_image.src;
        }

        // update price ranges
        let price = this.currentVariant.price / 100;
        let compPrice = this.currentVariant.compare_at_price
          ? this.currentVariant.compare_at_price / 100
          : 0;

        bidDialogData = {
          price: price,
          betterPrice: Math.round(price * 0.95),
          goodPrice: Math.round(price * 0.9),
          comparePrice: compPrice,
          isBkrm: this.currentVariant.options[0] == "Bikeroom",
        };

        try {
          bidConstraints = getBidConstraints(bidDialogData);
          if (bidConstraints) {
            bidDialogData.betterPrice = Math.round(
              bidDialogData.price * (1 - bidConstraints.min)
            );
            bidDialogData.goodPrice = Math.round(
              bidDialogData.price * (1 - bidConstraints.max)
            );
            bidDialogData.input = bidConstraints.input;
          }
        } catch (e) {
          console.error(e);
        }

        bidDialogFormData.variantId = `${this.currentVariant.id}`;

        try {
          const limit = 8000 * Shopify.exchange_rate;
          let d = bidBtn.parentElement.dataset.modal;
          d = d.split("-");

          const countryNotAllowed = bidBtn.parentElement.dataset.market == 'united-kingdom';

          if (price >= limit || countryNotAllowed) {
            d[1] = "bidform";
            bidBtn.children[0].innerHTML = bidBtn.parentElement.dataset.form;
          } else {
            d[1] = "bid";
            bidBtn.children[0].innerHTML = bidBtn.parentElement.dataset.text;
          }
          d = d.join("-");
          bidBtn.parentElement.dataset.modal = d;
        } catch (e) {
          console.error(e);
        }
      }
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector("select")) {
          this.options.push(fieldset.querySelector("select").value);
        } else if (fieldset.querySelectorAll("input").length) {
          this.options.push(fieldset.querySelector("input:checked").value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector(".form__label__value");
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    // updateMasterId() {
    //   this.currentVariant = this.getVariantData().find((variant) => {
    //     return !variant.options.map((option, index) => {
    //       return this.options[index] === option;
    //     }).includes(false);
    //   });
    // }

    updateMasterId() {
      const v = this.getVariantData().toSorted((a, b) => {
        const nameA = a.option1.toUpperCase(); // ignore upper and lowercase
        const nameB = b.option1.toUpperCase(); // ignore upper and lowercase

        if (nameA === "BIKEROOM" || nameA === "002") {
          return -1;
        }
        if (nameB === "BIKEROOM" || nameB === "002") {
          return 1;
        }

        if (a.price < b.price) {
          return -1;
        }
        if (a.price > b.price) {
          return 1;
        }

        // names must be equal
        return 0;
      });

      this.currentVariant = v.find((variant) => {
        if (shopify_meta_hide[variant.id]) {
          return false;
        }
        if (variant.available === false) {
          return false;
        }
        return !variant.options
          .map((option, index) => {
            if (index === dealerOptionIndex) {
              return true;
            }
            return this.options[index] === option;
          })
          .includes(false);
      });
      if (this.currentVariant === undefined) {
        this.currentVariant = v.find((variant) => {
          if (shopify_meta_hide[variant.id]) {
            return false;
          }
          return !variant.options
            .map((option, index) => {
              if (index === dealerOptionIndex) {
                return true;
              }
              return this.options[index] === option;
            })
            .includes(false);
        });
      }
      if (this.currentVariant === undefined) {
        if (this.currentVariant === undefined) {
          this.currentVariant = {
            option1: this.options[0],
            option2: this.options[1],
            option3: this.options[2],
            id: 123,
            options: this.options,
            available: false,
            title: this.options.join(" / "),
          };
        }
      }
      //console.log("DEALER:", this.currentVariant?.option1)
    }

    updateOther() {
      if (this.dataset.updateUrl === "false") {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll("fieldset"),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector("select")) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll("input").length) {
            fieldsets_array[i].querySelector(
              `input[value='${option}']`
            ).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      let productSlider = document.querySelector(
          ".thb-product-detail .product-images"
        ),
        thumbnails = document.querySelector(
          ".thb-product-detail #Product-Thumbnails"
        );

      this.setActiveMedia(
        `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        productSlider,
        thumbnails
      );
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider?.querySelector(mediaId);

      if (flkty && this.hideVariants) {
        if (
          productSlider?.querySelector(
            ".product-images__slide.is-initial-selected"
          )
        ) {
          productSlider
            ?.querySelector(".product-images__slide.is-initial-selected")
            ?.classList.remove("is-initial-selected");
        }
        [].forEach.call(
          productSlider?.querySelectorAll(
            ".product-images__slide-item--variant"
          ),
          function (el) {
            el?.classList.remove("is-active");
          }
        );

        activeMedia?.classList.add("is-active");
        activeMedia?.classList.add("is-initial-selected");

        this.setImageSetMedia();

        if (thumbnails) {
          let activeThumb = thumbnails?.querySelector(thumbId);

          if (
            thumbnails?.querySelector(".product-thumbnail.is-initial-selected")
          ) {
            thumbnails
              ?.querySelector(".product-thumbnail.is-initial-selected")
              ?.classList.remove("is-initial-selected");
          }
          [].forEach.call(
            thumbnails?.querySelectorAll(
              ".product-images__slide-item--variant"
            ),
            function (el) {
              el?.classList.remove("is-active");
            }
          );

          activeThumb?.classList.add("is-active");
          activeThumb?.classList.add("is-initial-selected");
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);
      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

      const currentImage =
        document.querySelector(mediaId)?.firstElementChild.children[1];
      if (currentImage?.src) {
        let im = document.getElementById(
          "product-sel-variant-hotspot"
        )?.firstElementChild;

        if (!im) return;
        let rep = currentImage.cloneNode(false);
        im.replaceWith(rep);
        im.setAttribute(
          "style",
          "mix-blend-mode: multiply; padding-right: 10px; padding-left: 10px;"
        );
      }
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }

    updateShareUrl() {
      const shareButton = document.getElementById(
        `Share-${this.dataset.section}`
      );
      if (!shareButton) return;
      shareButton.updateUrl(
        `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment`
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(
          new Event("change", {
            bubbles: true,
          })
        );
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector(
        ".pickup-availability-wrapper"
      );

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute("available");
        pickUpAvailability.innerHTML = "";
      }
    }

    removeErrorMessage() {
      const section = this.closest("section");
      if (!section) return;

      const productForm = section.querySelector("product-form");
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [
        `price-${this.dataset.section}`,
        `price-${this.dataset.section}--sticky`,
        `product-image-${this.dataset.section}--sticky`,
        `inventory-${this.dataset.section}`,
        `sku-${this.dataset.section}`,
        `quantity-${this.dataset.section}`,
      ];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(
        `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
      )
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + "--sticky");

            if (price) price.classList.remove("visibility-hidden");
            if (price_fixed) price_fixed.classList.remove("visibility-hidden");
          });
          this.toggleAddButton(
            !this.currentVariant.available,
            window.theme.variantStrings.soldOut
          );
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(
        `product-form-${this.dataset.section}`
      );
      if (!productForm) return;

      const productTemplate = productForm
        .closest(".product-form")
        .getAttribute("template");
      const submitButtons = document.querySelectorAll(
        ".single-add-to-cart-button"
      );

      if (!submitButtons) return;
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector(
          ".single-add-to-cart-button--text"
        );

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute("disabled", "disabled");
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute("disabled");
          submitButton.classList.remove("loading");

          if (productTemplate?.includes("pre-order")) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent =
              window.theme.variantStrings.addToCart;
          }
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll(
        ".single-add-to-cart-button"
      );
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(
        `price-${this.dataset.section}--sticky`
      );
      const trade_button = document.getElementById("trade-in-btn");

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector(
          ".single-add-to-cart-button--text"
        );
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add("sold-out");
      });
      if (price) price.classList.add("visibility-hidden");
      if (price_fixed) price_fixed.classList.add("visibility-hidden");
      if (trade_button) trade_button.disabled = true;
    }

    setDisabled() {
      if (this.isDisabledFeature != "true") {
        return;
      }
      const variant_data = this.getVariantData();

      if (variant_data) {
        const selected_options = this.currentVariant?.options.map(
          (value, index) => {
            return {
              value,
              index: `option${index + 1}`,
            };
          }
        );
        const available_options = this.createAvailableOptionsTree(
          variant_data,
          selected_options
        );
        console.log(available_options);

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector("select")) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector(
                    "option[value=" + JSON.stringify(option.value) + "]"
                  ).disabled = true;
                } else {
                  fieldset.querySelector(
                    "option[value=" + JSON.stringify(option.value) + "]"
                  ).disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll("input").length) {
              fieldset.querySelectorAll("input").forEach((input, input_i) => {
                input.classList.toggle(
                  "is-disabled",
                  fieldset_options[input_i].isUnavailable
                );
              });
            }
          }
        });
      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/-$/, "")
        .replace(/^-/, "");
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector("[data-set-name]");
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector(
          '.product-form__input[data-handle="' + this.imageSetName + '"]'
        ).dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      let setValue = this.getImageSetName(
        this.currentVariant[this.imageSetIndex]
      );
      let group = this.imageSetName + "_" + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(
          `.product-images__slide[data-set-name="${this.imageSetName}"]`
        ),
        selected_set_thumbs = this.productWrapper.querySelectorAll(
          `.product-thumbnail[data-set-name="${this.imageSetName}"]`
        );

      if (this.hideVariants) {
        // Product images
        this.productWrapper
          .querySelectorAll(".product-images__slide")
          .forEach((thumb) => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove("is-active");
            }
          });
        selected_set_images.forEach((thumb) => {
          thumb.classList.toggle("is-active", thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper
          .querySelectorAll(".product-thumbnail")
          .forEach((thumb) => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove("is-active");
            }
          });
        selected_set_thumbs.forEach((thumb) => {
          thumb.classList.toggle("is-active", thumb.dataset.group === group);
        });
      }
    }

    createAvailableOptionsTree(variant_data, selected_options) {
      console.log(selected_options);
      // Reduce variant array into option availability tree
      return variant_data.reduce(
        (options, variant) => {
          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach((index) => {
            if (variant[index] === null) return;

            // let another_entry_active = options[index].some(option => option.value === variant[index] && !option.isUnavailable);

            let entry = options[index].find(
              (option) => option.value === variant[index]
            );

            if (typeof entry === "undefined") {
              // If option has yet to be added to the options tree, add it
              entry = {
                value: variant[index],
                isUnavailable: true,
              };
              options[index].push(entry);
            }

            // Check how many selected option values match a variant
            const countVariantOptionsThatMatchCurrent =
              selected_options?.reduce((count, { value, index }) => {
                return variant[index] === value ||
                  index === "option" + (dealerOptionIndex + 1)
                  ? count + 1
                  : count;
              }, 0);
            //console.log(countVariantOptionsThatMatchCurrent)
            //console.log(entry)
            // Only enable an option if an available variant matches all but one current selected value
            if (
              countVariantOptionsThatMatchCurrent >=
              selected_options?.length - 1
            ) {
              entry.isUnavailable =
                entry.isUnavailable &&
                (variant.available && !shopify_meta_hide[variant.id]
                  ? false
                  : entry.isUnavailable);
            }
            //console.log(entry)
            // if(selected_options?.find((option) =>  || (option.value === entry.value && index === option.index))) {
            //   entry.isUnavailable = entry.isUnavailable && variant.available ? shopify_meta_hide[variant.id] : entry.isUnavailable;
            // }

            // entry.isUnavailable = entry.isUnavailable && variant.available ? shopify_meta_hide[variant.id] : entry.isUnavailable;
            // Make sure if a variant is unavailable, disable currently selected option
            if (
              (!this.currentVariant || !this.currentVariant.available) &&
              selected_options?.find(
                (option) =>
                  variant.available &&
                  !shopify_meta_hide[variant.id] &&
                  option.value === entry.value &&
                  index === option.index
              )
            ) {
              entry.isUnavailable = true;
            }
            //console.log(entry)
            const excludedKey = "option" + (dealerOptionIndex + 1);
            const firstKey = Object.keys(options).find(
              (key) => key !== excludedKey
            );

            const secondKey = Object.keys(options).findLast(
              (key) => key !== excludedKey
            );
            // console.log(index == firstKey)
            //console.log(variant.available && !shopify_meta_hide[variant.id])
            if (index == firstKey) {
              entry.isUnavailable =
                entry.isUnavailable &&
                (variant.available && !shopify_meta_hide[variant.id]
                  ? false
                  : entry.isUnavailable);
            }
            //console.log(entry)
          });

          //console.log(variant)

          //console.log(JSON.stringify(options))

          return options;
        },
        {
          option1: [],
          option2: [],
          option3: [],
        }
      );
    }

    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    updateMinPrice(price) {
      const m =
        document.querySelector("#am-omnibus-block")?.children[0]?.innerHTML;

      if (!m) return;

      if (!this.currentVariant && !price) {
        const cont =
          document.querySelector("#am-omnibus-block").parentElement
            .parentElement;
        if (cont) {
          cont.classList.add("hidden");
        }
        return;
      }

      const cr = Shopify.exchange_rate / Shopify.currency.rate;

      let p = price ?? this.currentVariant?.price;
      p = p / 100;

      p = p / Shopify.currency.rate;

      let ngp = m.split(":");
      ngp = ngp[1];
      ngp = ngp?.split("<")[0];
      ngp = Number(ngp.replace(/[^0-9]+/g, "")) / 100;

      let gp = (ngp * cr) / Shopify.currency.rate;

      const cont =
        document.querySelector("#am-omnibus-block").parentElement.parentElement;

      let ht = m.split(":");
      ht[1] = ht[1].split("<");
      ht[1][0] = Shopify.formatMoney(Math.round(ngp * cr) * 100);

      ht[1] = ht[1].join("<");
      ht = ht.join(": ");

      if (Math.abs(gp - p) > 5) {
        if (!cont) return;
        if (!cont.querySelector(".tooltip")) {
          const tooltip = `
											<div class="tooltip" style="padding-top: 2px">
												<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path d="M7.45 11.6166H8.56666V7.7166H7.45V11.6166ZM7.99473 6.5666C8.1538 6.5666 8.28889 6.5128 8.4 6.4052C8.51111 6.2976 8.56666 6.16427 8.56666 6.0052C8.56666 5.84613 8.51286 5.71105 8.40526 5.59994C8.29766 5.48882 8.16433 5.43327 8.00526 5.43327C7.8462 5.43327 7.71111 5.48707 7.6 5.59467C7.48888 5.70227 7.43333 5.8356 7.43333 5.99467C7.43333 6.15374 7.48713 6.28882 7.59473 6.39994C7.70233 6.51105 7.83566 6.5666 7.99473 6.5666ZM8.0046 14.7333C7.14701 14.7333 6.33956 14.5707 5.58225 14.2456C4.82492 13.9204 4.16216 13.4732 3.59396 12.9039C3.02576 12.3346 2.57916 11.6719 2.25416 10.9158C1.92916 10.1598 1.76666 9.35193 1.76666 8.4923C1.76666 7.63176 1.92923 6.82561 2.25438 6.07385C2.57952 5.32209 3.02675 4.6621 3.59605 4.0939C4.16535 3.5257 4.82803 3.0791 5.5841 2.7541C6.34015 2.4291 7.148 2.2666 8.00763 2.2666C8.86817 2.2666 9.67432 2.42917 10.4261 2.75432C11.1778 3.07946 11.8378 3.52668 12.406 4.09599C12.9742 4.66529 13.4208 5.32667 13.7458 6.08014C14.0708 6.83359 14.2333 7.63866 14.2333 8.49534C14.2333 9.35292 14.0708 10.1604 13.7456 10.9177C13.4205 11.675 12.9732 12.3378 12.4039 12.906C11.8346 13.4742 11.1733 13.9208 10.4198 14.2458C9.66634 14.5708 8.86127 14.7333 8.0046 14.7333ZM8 13.6166C9.41666 13.6166 10.6236 13.118 11.6208 12.1208C12.6181 11.1235 13.1167 9.9166 13.1167 8.49994C13.1167 7.08327 12.6181 5.87632 11.6208 4.8791C10.6236 3.88188 9.41666 3.38327 8 3.38327C6.58333 3.38327 5.37638 3.88188 4.37916 4.8791C3.38194 5.87632 2.88333 7.08327 2.88333 8.49994C2.88333 9.9166 3.38194 11.1235 4.37916 12.1208C5.37638 13.118 6.58333 13.6166 8 13.6166Z" fill="#6A6C6F"/>
												</svg>
												<span class="tooltiptext">${fryTooltopText}</span>
											</div>
										`;
          cont.insertAdjacentHTML("beforeend", tooltip);
        }

        let bbb = document.querySelector("#am-omnibus-block")?.children[0];
        if (bbb) {
          bbb.innerHTML = ht;
        }

        cont.classList.add("jsb");
        cont.classList.remove("hidden");
      } else {
        if (!cont) return;
        cont.classList.add("hidden");
      }
    }
  }
  customElements.define("variant-selects", VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      });
    }
  }

  customElements.define("variant-radios", VariantRadios);
}

if (!customElements.get("product-slider")) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener("change", this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest(".thb-product-detail");
      this.thumbnail_container = this.product_container.querySelector(
        ".product-thumbnail-container"
      );
      this.video_containers = this.querySelectorAll(
        ".product-single__media-external-video--play"
      );

      this.setOptions();
      // Start Slider
      this.init();
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == "true";
      this.thumbnails =
        this.thumbnail_container.querySelectorAll(".product-thumbnail");
      this.prev_button = this.querySelector(".flickity-prev");
      this.next_button = this.querySelector(".flickity-next");
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: ".is-initial-selected",
        prevNextButtons: false,
        fade: false,
        cellSelector: ".product-images__slide.is-active",
      };
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit(imageSetIndex) {
      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener("click", (event) => {
          this.flkty.previous();
        });
        prev.addEventListener("keyup", (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener("click", (event) => {
          this.flkty.next();
        });
        next.addEventListener("keyup", (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container
          .querySelector("button")
          .addEventListener("click", function () {
            container.setAttribute("hidden", "");
          });
      });
      this.flkty.on("settle", function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on("change", (index) => {
        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector(
            ".product-single__media"
          ),
          active_thumbs = Array.from(this.thumbnails).filter((element) =>
            element.classList.contains("is-active")
          ),
          active_thumb = active_thumbs[index]
            ? active_thumbs[index]
            : active_thumbs[0];

        this.thumbnails.forEach((item, i) => {
          item.classList.remove("is-initial-selected");
        });
        active_thumb.classList.add("is-initial-selected");

        requestAnimationFrame(() => {
          if (active_thumb.offsetParent === null) {
            return;
          }
          const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
            windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
          active_thumb.parentElement.scrollTo({
            left:
              active_thumb.offsetLeft -
              windowHalfWidth +
              active_thumb.clientWidth / 2,
            top:
              active_thumb.offsetTop -
              windowHalfHeight +
              active_thumb.clientHeight / 2,
            behavior: "smooth",
          });
        });

        // Stop previous video
        if (
          previous_media.classList.contains(
            "product-single__media-external-video"
          )
        ) {
          if (previous_media.dataset.provider === "youtube") {
            previous_media.querySelector("iframe").contentWindow.postMessage(
              JSON.stringify({
                event: "command",
                func: "pauseVideo",
                args: "",
              }),
              "*"
            );
          } else if (previous_media.dataset.provider === "vimeo") {
            previous_media.querySelector("iframe").contentWindow.postMessage(
              JSON.stringify({
                method: "pause",
              }),
              "*"
            );
          }
          previous_media
            .querySelector(".product-single__media-external-video--play")
            .removeAttribute("hidden");
        } else if (
          previous_media.classList.contains(
            "product-single__media-native-video"
          )
        ) {
          previous_media.querySelector("video").pause();
        }
      });

      setTimeout(() => {
        let active_thumbs = Array.from(this.thumbnails).filter(
          (element) => element.clientWidth > 0
        );
        active_thumbs.forEach((thumbnail, index) => {
          thumbnail.addEventListener("click", () => {
            this.thumbnailClick(thumbnail, index);
          });
        });
      });
    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove("is-initial-selected");
      });
      thumbnail.classList.add("is-initial-selected");
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll(".product-single__media-zoom").length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(
        this.querySelectorAll(
          ".product-images__slide.is-active .product-single__media-image"
        )
      );

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(
          item.parentNode.parentNode.children,
          item.parentNode
        );

        let activelink = item.querySelector(".product-single__media-zoom");

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute("href"),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll(".product-single__media-zoom");
      this.pswpElement = document.querySelectorAll(".pswp")[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector(
              ".product-images__slide.is-selected"
            ),
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width,
          };
        },
      };

      this.links.forEach((link) => {
        link.addEventListener("click", (e) => this.zoomClick(e, link));
      });
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== "undefined") {
        let pswp = new PhotoSwipe(
          this.pswpElement,
          PhotoSwipeUI_Default,
          this.items,
          this.pswpOptions
        );
        pswp.listen("firstUpdate", function () {
          pswp.listen("parseVerticalMargin", function (item) {
            item.vGap = {
              top: 50,
              bottom: 50,
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define("product-slider", ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.sticky = this.dataset.sticky;
        this.form = document.getElementById(
          `product-form-${this.dataset.section}`
        );
        this.form.querySelector("[name=id]").disabled = false;
        if (!this.sticky) {
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        }
        this.cartNotification = document.querySelector("cart-notification");
        this.body = document.body;

        this.hideErrors = this.dataset.hideErrors === "true";
      }
      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.form.reportValidity()) {
          return;
        }

        const submitButtons = document.querySelectorAll(
          ".single-add-to-cart-button"
        );

        submitButtons.forEach((submitButton) => {
          if (submitButton.classList.contains("loading")) return;
          submitButton.setAttribute("aria-disabled", true);
          submitButton.classList.add("loading");
        });

        this.handleErrorMessage();

        const config = {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/javascript",
          },
        };

        let formData = new FormData(this.form);

        formData.append(
          "sections",
          this.getSectionsToRender().map((section) => section.section)
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              dispatchCustomEvent("product:variant-error", {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              return;
            }

            this.renderContents(response);

            dispatchCustomEvent("cart:item-added", {
              product: response.hasOwnProperty("items")
                ? response.items[0]
                : response,
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButtons.forEach((submitButton) => {
              submitButton.classList.remove("loading");
              submitButton.removeAttribute("aria-disabled");
            });
          });
      }

      getSectionsToRender() {
        return [
          {
            id: "Cart",
            section: "main-cart",
            selector: ".thb-cart-form",
          },
          {
            id: "Cart-Drawer",
            section: "cart-drawer",
            selector: ".cart-drawer",
          },
          {
            id: "cart-drawer-toggle",
            section: "cart-bubble",
            selector: ".thb-item-count",
          },
        ];
      }
      renderContents(parsedState) {
        this.getSectionsToRender().forEach((section) => {
          // #cart-drawer-toggle is rendered twice (mobile + desktop header variants).
          // querySelectorAll catches both so the visible badge updates on every viewport.
          const containers = document.querySelectorAll("#" + section.id);
          if (!containers.length) {
            return;
          }
          const newInner = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
          containers.forEach((container) => {
            const elementToReplace =
              container.querySelector(section.selector) || container;
            elementToReplace.innerHTML = newInner;
          });

          if (typeof CartDrawer !== "undefined") {
            new CartDrawer();
          }
          if (typeof Cart !== "undefined") {
            new Cart().renderContents(parsedState);
          }
        });

        let product_drawer = document.getElementById("Product-Drawer"),
          search_drawer = document.getElementById("Search-Drawer");

        if (search_drawer.classList.contains("active")) {
          search_drawer.classList.remove("active");
        }
        if (product_drawer && product_drawer.contains(this)) {
          product_drawer.classList.remove("active");
          this.body.classList.remove("open-cc--product");
          if (
            document.getElementById("Cart-Drawer") &&
            window?.location.pathname !== "/cart"
          ) {
            this.body.classList.add("open-cc");
            document.getElementById("Cart-Drawer").classList.add("active");
          }
        } else if (document.getElementById("Cart-Drawer")) {
          this.body.classList.add("open-cc");
          document.getElementById("Cart-Drawer").classList.add("active");
          dispatchCustomEvent("cart-drawer:open");
        }
      }
      getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(selector).innerHTML;
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get("product-add-to-cart-sticky")) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled =
        document.body.classList.contains("animations-true") &&
        typeof gsap !== "undefined";
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    setupToggle() {
      const button = this.querySelector(".product-add-to-cart-sticky--inner"),
        content = this.querySelector(".product-add-to-cart-sticky--content");

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add("sticky-open");
          },
          onReverseComplete: () => {
            button.classList.remove("sticky-open");
          },
        });

        tl.set(
          content,
          {
            display: "block",
            height: "auto",
          },
          "start"
        ).from(
          content,
          {
            height: 0,
            duration: 0.25,
          },
          "start+=0.001"
        );

        button.addEventListener("click", function () {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener("click", function () {
          content.classList.toggle("active");
          return false;
        });
      }
    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach((entry) => {
              if (entry.target === footer) {
                if (entry.intersectionRatio > 0) {
                  _this.classList.remove("sticky--visible");
                } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                  _this.classList.add("sticky--visible");
                }
              }
              if (entry.target === form) {
                let boundingRect = form.getBoundingClientRect();

                if (
                  entry.intersectionRatio === 0 &&
                  window.scrollY > boundingRect.top + boundingRect.height
                ) {
                  _this.formPassed = true;
                  _this.classList.add("sticky--visible");
                } else if (entry.intersectionRatio === 1) {
                  _this.formPassed = false;
                  _this.classList.remove("sticky--visible");
                }
              }
            });
          },
          {
            threshold: [0, 1],
          }
        ),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById("footer");
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define("product-add-to-cart-sticky", ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get("side-panel-links")) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll("button");
      this.drawer = document.getElementById("Product-Information-Drawer");
      this.buttons = this.drawer.querySelector(".side-panel-content--tabs");
      this.panels = this.drawer
        .querySelector(".side-panel-content--inner")
        .querySelectorAll(".side-panel-content--tab-panel");
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {}
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener("click", (e) => {
          this.body.classList.add("open-cc");
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add("active");
        });
      });
    }
  }

  customElements.define("side-panel-links", ProductSidePanelLinks);
}
